module.exports = __webpack_public_path__ + "static/media/aromaterapie.049ccdf2.svg";